// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__N5Qbg","clear":"styles_clear__6f8iF"};